import { useCallback } from 'react';

import { fg } from '@confluence/feature-gating';
import {
	deserializeState,
	useGetOnboardingState,
	useSetOnboardingState,
} from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingState.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { AccessStatus } from '@confluence/session-data/entry-points/SiteInformationQuery.ts';
import { MODERNIZE_CONFLUENCE_IPM_MODAL } from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants.ts';

const isLicensed = (accessStatus: AccessStatus | null) =>
	accessStatus === AccessStatus.LICENSED_USE_ACCESS ||
	accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS;

export const useModernizeBanner = () => {
	const { accessStatus } = useSessionData();
	const { data, loading, error } = useGetOnboardingState(
		Object.values(MODERNIZE_CONFLUENCE_IPM_MODAL),
		!isLicensed(accessStatus) || !fg('cc_onboarding_modernize_confluence_ipm_modal'),
	);
	const { setOnboardingState } = useSetOnboardingState();

	const { hasDismissedModernizeConfluenceBanner, hasDismissedModernizeConfluenceIpmModal } =
		deserializeState(data);
	const onDismiss = useCallback(() => {
		setOnboardingState({
			key: MODERNIZE_CONFLUENCE_IPM_MODAL.HAS_DISMISSED_BANNER,
			value: 'true',
		});
	}, [setOnboardingState]);

	if (!fg('cc_onboarding_modernize_confluence_ipm_modal') || !isLicensed(accessStatus)) {
		return {
			isVisible: false,
			onDismiss: () => {},
		};
	}

	if (error) {
		return {
			error,
			isVisible: false,
			onDismiss: () => {},
		};
	}

	if (loading) {
		return {
			loading,
			isVisible: false,
			onDismiss: () => {},
		};
	}
	if (!hasDismissedModernizeConfluenceIpmModal) {
		return {
			isVisible: false,
			onDismiss: () => {},
		};
	}
	return {
		isVisible: !hasDismissedModernizeConfluenceBanner,
		onDismiss,
	};
};
